var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header mt-5 mb-7"},[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.pageSection))]),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.pageTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }